import { Tooltip } from 'antd';
import { createStyles } from 'antd-style';
import React, { ReactElement, ReactNode } from 'react';

type BorderTooltipProps = React.ComponentProps<typeof Tooltip> & {
  borderColor?: string;
  children: ReactNode;
};

const useStyles = createStyles(() => {
  return {
    tooltip: {
      '.ant-tooltip-content': {
        color: '#1DA57A',
        border: '1px solid #1DA57A'
      },
      '.ant-tooltip-arrow': {
        color: '#1DA57A'
      },
      '.ant-tooltip-inner': {
        color: '#1DA57A'
      }
    }
  };
});

export default function BorderTooltip(props: BorderTooltipProps): ReactElement {
  const { borderColor, children, arrow, ...rest } = props;
  const { cx, styles } = useStyles();
  return <Tooltip {...rest}>{children}</Tooltip>;
}
